<template>
    <div class="patient_status_view_section">
        <LoadingOverlay :activeSyncProps="activeSync" :isFullPageProps="true"/>
        <ListTable :headerItems="headerItems"
                   :itemRows="itemRows"
        />
    </div>
</template>
<script>
    import ListTable from "../../../../../Table/listTable/index";
    import {_MMT_GRADE_RANGE, _MRS_RANGE, _Y_N_RANGE} from '@/components/Table/static'
    import _API from "../../../../../../api";
    import LoadingOverlay from '@/components/loadingOverlay'
    import {mapMutations} from "vuex";

    export default {
        name: 'PatientStatusView',
        props: ['patientProps'],
        components: {ListTable, LoadingOverlay},
        data() {
          const check = this.patientProps?.check === undefined ? true : this.patientProps?.check;

          return {
            headerItems: [
              {
                index: 0,
                keyTitle: this.$t('table.header.date_entry'),
                keyType: 'HeaderDefault',
                parentClass: [],
                componentOptions: {},
                keyRange: [],
                values: '',
              },
              {
                index: 1,
                keyTitle: this.$t('patient.condition.paralysis_part'),
                keyType: 'HeaderDefault',
                parentClass: [],
                componentOptions: {},
                keyRange: [],
                values: '',
              },
              {
                index: 2,
                keyTitle: this.$t('patient.condition.infection'),
                keyType: 'HeaderDefault',
                parentClass: [],
                componentOptions: {},
                keyRange: [],
                values: '',
              },
              {
                index: 3,
                keyTitle: this.$t('unit.MMT.name'),
                keyType: 'HeaderDefault',
                parentClass: [],
                componentOptions: {},
                keyRange: [],
                values: '',
              },
              {
                index: 4,
                keyTitle: this.$t('unit.MRS.name'),
                keyType: 'HeaderDefault',
                parentClass: [],
                componentOptions: {},
                keyRange: [],
                values: '',
              },
              {
                index: 5,
                keyTitle: this.$t('patient.condition.medicine'),
                keyType: 'HeaderDefault',
                parentClass: [],
                componentOptions: {},
                keyRange: [],
                values: '',
              },
              check && {
                index: 6,
                keyTitle: this.$t('status.delete'),
                keyType: 'HeaderDefault',
                parentClass: [],
                componentOptions: {},
                keyRange: [],
                values: '',
              },
            ],
            patientStatusList: [],
            itemRows: '',
            activeSync: false
          }
        },
        methods: {
            ...mapMutations(['setPatientStatus']),
            getPatientStatusList() {
                if (!this.patientProps.patientInfo.seqMedicalRelation) {
                    return
                }
                const seqMedicalRelation = this.patientProps.patientInfo.seqMedicalRelation;
                return new Promise((resolve, reject) => {
                    _API.PATIENT.getPatientStatusListFromServerBySeqMedicalRelation(seqMedicalRelation)
                        .then(res => {
                            this.patientStatusList = res.data.patientStatusList;
                            this.patientStatusList.sortByOrder('createDatetime', true);
                            resolve();
                        })
                        .catch(e => {
                            reject(`[getPatientStatusListFromServerBySeqMedicalRelation] ${e}`)
                        });
                });
            },
            confirmDeletion(rowIndex, seqPatientStatus) {
                this.$modal.show('yes-or-no-modal', {
                    questionType: 'reallyDelete',
                    function: this.deleteStatusItem,
                    funcParam: {rowIndex, seqPatientStatus}
                });
            },
            deleteStatusItem(params) {
                this.activeSync = true;
                return new Promise((resolve, reject) => {
                    _API.PATIENT.deleteStatusItemFromServer(params.seqPatientStatus)
                        .then(async ({data}) => {
                            if (data.failedCode === '0' && data.isSuccess) {
                                this.$modal.show('common-alert-modal', {
                                  messageType: 'short',
                                  message: 'alert.delete_completed'
                                });

                                // filter를 동기적으로 만들기 위한 코드
                                const promises = await this.patientStatusList.map(value => value);
                                const promisesArr = await Promise.all(promises);
                                this.patientStatusList = this.patientStatusList.filter((_x, index) => {
                                    const status = promisesArr[index];
                                    return status.seqPatientStatus !== params.seqPatientStatus
                                });
                                // vuex 갱신
                                const patientStatus = {
                                    createDatetime: '',
                                    patientStatusInfection: '',
                                    patientStatusMMT: null,
                                    patientStatusMRS: null,
                                    patientStatusMedication: '',
                                    patientStatusParalysisPart: '',
                                    patientStatusParalysisPosition: '',
                                    seqMedicalRelation: 0,
                                    seqPatientStatus: 0
                                };
                                const seqMedicalRelation = this.patientProps.patientInfo.seqMedicalRelation;
                                if (this.patientStatusList.length === 0) {
                                    // 남은 아이템이 없는 경우 초기화
                                    this.setPatientStatus({seqMedicalRelation, patientStatus});
                                } else if (params.rowIndex === 0) {
                                    // 리스트가 여러개이면서, 리스트의 첫번째 아이템을 삭제했을 경우, 남은 리스트중 가장 앞의 아이템을 업데이트
                                    this.setPatientStatus({
                                        seqMedicalRelation,
                                        patientStatus: this.patientStatusList.slice().shift()
                                    });
                                }
                                this.activeSync = false;
                                resolve();
                            } else {
                                this.$modal.show('common-alert-modal', {
                                  messageType: 'short',
                                  message: 'alert.unexpected_error'
                                });
                                this.activeSync = false;
                                resolve();
                            }
                        })
                        .catch(e => {
                            this.activeSync = false;
                            reject(`[deleteStatusItemFromServer] ${e}`)
                        });
                });
            }
        },
        created() {
            this.getPatientStatusList();
        },
        watch: {
            patientStatusList() {
                const itemRows = [];

                for (let i = 0; i < this.patientStatusList.length; i++) {
                  const items = [];
                  items.clickEvent = {
                    func: '',
                    params: '',
                    key: 'none'
                  }
                  items.push({
                    index: 0,
                    keyTitle: '',
                    keyType: 'Default',
                    class: [''],
                    parentClass: [],
                    componentOptions: {},
                    keyRange: [],
                    values: this.moment(this.patientStatusList[i].createDatetime).locale(this.$t('country')).format('ll'),
                  });
                  items.push({
                    index: 1,
                    keyTitle: '',
                    keyType: 'Default',
                    class: [''],
                    parentClass: [],
                    componentOptions: {},
                    keyRange: [],
                    values: this.patientStatusList[i].patientStatusParalysisPart,
                  });
                  items.push({
                    index: 2,
                    keyTitle: '',
                    keyType: 'Default',
                    class: [''],
                    parentClass: [],
                    componentOptions: {},
                    keyRange: [],
                    values: this.patientStatusList[i].patientStatusInfection === '' ||
                    this.patientStatusList[i].patientStatusInfection === null ||
                    this.patientStatusList[i].patientStatusInfection === undefined ?
                        '-' : _Y_N_RANGE[Number(this.patientStatusList[i].patientStatusInfection)].title
                  });
                  items.push({
                    index: 3,
                    keyTitle: '',
                    keyType: 'Default',
                    class: [''],
                    parentClass: [],
                    componentOptions: {},
                    keyRange: [],
                    values: this.patientStatusList[i].patientStatusMMT === '' ||
                    this.patientStatusList[i].patientStatusMMT === null ||
                    this.patientStatusList[i].patientStatusMMT === undefined ?
                        'N/A' : _MMT_GRADE_RANGE[Number(this.patientStatusList[i].patientStatusMMT) + 1].title
                  });
                  items.push({
                    index: 4,
                    keyTitle: '',
                    keyType: 'Default',
                    class: [''],
                    parentClass: [],
                    componentOptions: {},
                    keyRange: [],
                    values: this.patientStatusList[i].patientStatusMRS === '' ||
                    this.patientStatusList[i].patientStatusMRS === null ||
                    this.patientStatusList[i].patientStatusMRS === undefined ?
                        'N/A' : _MRS_RANGE[Number(this.patientStatusList[i].patientStatusMRS) + 1].title,
                  });
                  items.push({
                    index: 5,
                    keyTitle: '',
                    keyType: 'Default',
                    class: [''],
                    parentClass: [],
                    componentOptions: {},
                    keyRange: [],
                    values: this.patientStatusList[i].patientStatusMedication,
                  });
                  this.patientProps.check && items.push({
                    index: 6,
                    keyTitle: '',
                    keyType: 'DeleteBtn',
                    class: [''],
                    parentClass: [],
                    componentOptions: {},
                    keyRange: [],
                    rowIndex: i, // 내가 클릭한 값의 인덱스가 궁금해서
                    values: this.patientStatusList[i].seqPatientStatus,
                    function: this.confirmDeletion
                  });
                  itemRows.push(items);
                }

                this.itemRows = itemRows;
            },
            patientProps: {
                deep: true,
                handler() {
                    this.getPatientStatusList();
                }
            }
        }
    }
</script>
<style lang="scss">
.patient_status_view_section {
  .table-container {
    grid-template-rows: repeat(auto-fill, 3rem) !important;
  }
}
</style>